import { DataDRequest } from "../DRequest";
import { Global } from "../Global";
import { IFacturaCFDIConceptosFiscalesProcesados, IFacturaDetalleFolioFactura, IPagoInfoFacturarConceptoComplemento } from "../entidad/Factura";
import { DataUtil } from "../util/Util";

export function _SvFacturaCFDIProcesarConceptosFiscales(idEscuela: number, idAlumno: number, idsMovPagos: number[]):
    Promise<DataDRequest.IRequestResponseA<IFacturaCFDIConceptosFiscalesProcesados[]>> {

    const url = Global._GLOBAL_CONF.URL_RSTV2 + "factura/ProcesarConceptosFiscales"
    const params = {
        "IdEscuela": idEscuela,
        "IdAlumno": idAlumno,
        "IdsMovPagos": idsMovPagos,
    }
    return DataDRequest._Request5<IFacturaCFDIConceptosFiscalesProcesados[]>(url, "POST", params)
}

interface IFacturaCrearCFDIGeneralParams {
    IdOrganizacion?: number
    IdUsuario?: number
    IdEscuela: number
    IdAlumno: number
    /** UID cliente */
    UIDReceptor: string
    // TipoDocumento: string
    UsoCFDI: string // "S01"
    Serie: number // 57739
    FormaPago: string // "03"
    MetodoPago: string// "PUE"
    Fecha: string // "2024-04-19"
    EnviarCorreo: boolean // false
    LugarExpedicion: string // "44444"
    NumOrder: string // opcional
    Cuenta: string // opcional; ej: "1234567890"
    Banco: string // opcional; ej: "BANCOMEX"
    CondicionPago: string // opcional; ej: "Contado"
    Comentarios: string // opcional; ej: "Factura generada automáticamente"
    Conceptos: IFacturaCrearCFDIItemConcepto[]
}
export interface IFacturaCrearCFDIItemConcepto {
    IdsMovPagos: number[] // [3206]
    ClaveProdServSAT: string // "81112101"
    ClaveUnidadSAT: string // "18"
    NombreUnidadSAT: string // "Tambor de cincuenta y cinco galones (EUA)"
    Complemento: IPagoInfoFacturarConceptoComplemento
}

interface IFacturaCrearCFDIRespuesta {
    IdFolio: number
    /** @example "66270820bae12" */
    UID: string
    /** @example "99f228b5-aa4d-4113-9c22-eaf1fadddc05" */
    UUID: string
}
export function _SvFacturaCrearCFDI(cfdiInfo: IFacturaCrearCFDIGeneralParams): Promise<DataDRequest.IRequestResponseA<IFacturaCrearCFDIRespuesta>> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "factura/CrearCFDI"
    const params = <IFacturaCrearCFDIGeneralParams>{
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        ...cfdiInfo,
    }
    return DataDRequest._Request5<IFacturaCrearCFDIRespuesta>(url, "POST", params)
}

/** returns URL string
 * @example
 * ".../factura/ObtenerCfdiXml?..." || ".../factura/ObtenerCfdiPdf?..."
 */
export function _SvFacturaCreateURLArchivoCFDI(idEscuela: number, idFolio: number, extension: "xml" | "pdf") {
    const idUsuario = DataUtil._Usuario.IdUsuario
    const auxUrl = {
        "xml": "Xml",
        "pdf": "Pdf",
    }
    return Global._GLOBAL_CONF.URL_RSTV2 + `factura/ObtenerCfdi${auxUrl[extension]}?IdEscuela=${idEscuela}&IdFolio=${idFolio}&IdUsuario=${idUsuario}`;
}

export function _SvFacturaObtenerArchivoCFDI(idEscuela: number, idFolio: number, extension: "xml" | "pdf") {
    const url = _SvFacturaCreateURLArchivoCFDI(idEscuela, idFolio, extension);
    return new Promise<DataDRequest.IRequestResponseA<File>>(resolve => {
        DataDRequest._RequestBlobFromUrlResource(url, (fileBlob, err, response) => {
            const filename: string = response ? response.headers.get("Filename") : null
            resolve({
                Resultado: !err ? 1 : -1,
                Datos: !err ? new File([fileBlob], filename) : null,
            })
        })
    })
}

export function _SvFacturaObtenerDetalleFolioFactura(idFolio: number): Promise<DataDRequest.IRequestResponseA<IFacturaDetalleFolioFactura>> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "factura/ObtenerDetalleFolioFactura";
    const params = {
        IdFolio: idFolio,
    }
    return DataDRequest._Request5<IFacturaDetalleFolioFactura>(url, "GET", params).then(res => {
        const realDatos = res.Datos as any as IFacturaDetalleFolioFactura[] // el endpoint devuelve un array
        if (realDatos?.length > 0) {
            res.Datos = realDatos[0]
        }
        return res;
    })
}